import script from "./epc-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./epc-input.vue?vue&type=script&setup=true&lang=ts"

import "./epc-input.vue?vue&type=style&index=0&id=4346fb6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4346fb6c"]])

export default __exports__